import { api } from '@/lib/api';
import type {
  IApiResponse,
  IIssueInProgressDaily,
  IIssueInProgressDailyFilters,
  IIssueInProgressDailySummary,
} from '@skystone/shared';

// PRODOPSAI-418: `getTrend` was deleted — the four WIP-trend consumers now
// call `portfolioApi.getWipTrend` (canonical Story/Bug/Task, archived=false).
// `getAll` and `getSummary` remain because the admin table browser at
// `/admin/tbl-issue-in-progress-daily` (`IssueInProgressDailyPage.tsx`) is
// the only consumer of the raw daily-snapshot endpoint and is unaffected.

function buildQuery(filters?: IIssueInProgressDailyFilters): string {
  const params = new URLSearchParams();

  if (filters?.productId) params.set('productId', filters.productId);
  if (filters?.teamId) params.set('teamId', filters.teamId);
  if (filters?.issueType) params.set('issueType', filters.issueType);
  if (filters?.from) params.set('from', filters.from);
  if (filters?.to) params.set('to', filters.to);
  if (filters?.inProgressOnly !== undefined) params.set('inProgressOnly', String(filters.inProgressOnly));
  if (typeof filters?.limit === 'number') params.set('limit', String(filters.limit));
  if (typeof filters?.offset === 'number') params.set('offset', String(filters.offset));

  return params.toString();
}

export const issueInProgressDailyApi = {
  getAll: async (filters?: IIssueInProgressDailyFilters): Promise<IIssueInProgressDaily[]> => {
    const query = buildQuery(filters);
    const url = query ? `/issue-in-progress-daily?${query}` : '/issue-in-progress-daily';
    const result = await api.get<IApiResponse<IIssueInProgressDaily[]>>(url);
    return result.data;
  },

  getSummary: async (filters?: IIssueInProgressDailyFilters): Promise<IIssueInProgressDailySummary> => {
    const query = buildQuery(filters);
    const url = query ? `/issue-in-progress-daily/summary?${query}` : '/issue-in-progress-daily/summary';
    const result = await api.get<IApiResponse<IIssueInProgressDailySummary>>(url);
    return result.data;
  },
};
